import { Youtube } from "react-bootstrap-icons";
// strona rozpoczęcia procesu resetu hasła

import React from 'react';
import classnames from 'classnames';
import { Trans } from 'react-i18next';
import { useAppNavigate } from 'hooks';
import { Button, Container } from 'components/controls';
import styles from 'theme/pages/ThankYouRegister/ThankYouRegister.module.scss';
const ThankYouRegister = () => {
  const navigate = useAppNavigate();
  return <div className={classnames(styles.componentWrapper, 'StylePath-Pages-ThankYouRegister')}>
      <Container>
        <h1>
          <Trans>Dziękujemy za przesłanie zgłoszenia!</Trans>
        </h1>

        <p>
          <Trans>
            Cieszymy się, że chcesz dołączyć do grona partnerów biznesowych Intermal. Twoje zgłoszenie
            zostało zarejestrowane w naszym systemie.
          </Trans>
        </p>

        <h4>
          <Trans>Co teraz?</Trans>
        </h4>

        <ol>
          <li>
            <Trans>Sprawdź swoją skrzynkę e-mail - wysłaliśmy wiadomość z linkiem aktywacyjnym.</Trans>
          </li>
          <li>
            <Trans>
              Potwierdź adres e-mail, abyśmy mogli przejść do finalizacji procesu weryfikacji Twojego
              konta.
            </Trans>
          </li>
        </ol>

        <h4>
          <Trans>Chcesz szybciej wdrożyć się w obsługę Platformy B2B Intermal?</Trans>
        </h4>

        <p>
          <Trans>
            Zanim Twoje konto zostanie w pełni aktywowane, zapraszamy do naszej bazy wiedzy wideo.
            Przygotowaliśmy serię krótkich poradników, które pokazują, jak w pełni wykorzystać potencjał
            naszej platformy B2B i ułatwić Twoją pracę.
          </Trans>
        </p>

        <p className={styles.youtubeRow}>
          <Youtube className={styles.youtubeIcon} />
          <strong>
            <Trans>Obejrzyj instrukcje na YouTube</Trans>
          </strong>{' '}
          <Trans>Dowiedz się, jak składać zamówienia, zarządzać fakturami i zamówieniami</Trans>{' '}
          <a className={styles.youtubeLink} href="https://www.youtube.com/playlist?list=PL20Jweo2vswWvxxnU85RCgfyxU2FoLMRT" target="_blank" rel="noreferrer">
            <Trans>ZOBACZ</Trans>
          </a>
        </p>

        <div className={styles.actions}>
          <Button onClick={() => navigate('/')}>
            <Trans>Powrót na stronę główną</Trans>
          </Button>
        </div>
      </Container>
    </div>;
};
export default ThankYouRegister;